import { cardHolderValidationRules, cardNumberValidationRules, passwordValidationRules, qiwiWalletValidationRules } from '@validation/rules/account';
import { SPECIALIST_WALLET_TYPE } from '@types';
export const accountWithdrawFundsSettingsValidationRules = {
  [SPECIALIST_WALLET_TYPE.RUS_BANK_CARD]: cardNumberValidationRules,
  cardHolder: cardHolderValidationRules,
  [SPECIALIST_WALLET_TYPE.UKR_BANK_CARD]: cardNumberValidationRules,
  /**
   * @todo wait for webmoney approve
   * [SPECIALIST_WALLET_TYPE.WEBMONEY]: webmoneyWalletValidationRules,
   */
  [SPECIALIST_WALLET_TYPE.QIWI]: qiwiWalletValidationRules,
  password: passwordValidationRules
};